import { BehaviorSubject } from "rxjs";

export enum SeStepperSideNavComponentType {
    summary = 'summary',
    documents = 'documents'
}

export abstract class SeStepperSideComponentBase {
    isLoading = new BehaviorSubject<boolean>(false);
}
